import { render } from "./BrokerStatusBadge.vue?vue&type=template&id=1b454678"
import script from "./BrokerStatusBadge.vue?vue&type=script&lang=js"
export * from "./BrokerStatusBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__